import React from 'react';
import ArtemisDecisionPlatform from './ArtemisDecisionPlatform';

const DecisionMakerPlatform = () => {
  return (
    <div style={{ width: '100%' }}>
      <ArtemisDecisionPlatform />
    </div>
  );
};

export default DecisionMakerPlatform; 